import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ItemSpec ( props ) {

    return <BasicCrudScreenType id="ItemSpec" table="ItemSpec" view="VwItemSpec" />;

}

export default ItemSpec;
